<template>
  <div class="other-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <loading :active.sync="isLoading"></loading>
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
      <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img src="../assets/images/LOGO.png" alt="農科院農業課程報名及查詢系統:回首頁" />
        </a>
      </h1>
      <main class="training-content">
        <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C">:::</a>
        <h2 :class="!ms_ie?'training-h2':'training-h2-ie'">活動及研討會線上報名</h2>
        <div class="table-line"></div>
        <!-- 如果有內容才顯示 -->
        <div v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10">
  <template v-if="trainingList && trainingList.length > 0"
          >
          <div
            class="training-list"
            v-for="item in trainingList"
            :key="item.Id"
          >
            <div class="training-list-content">
              <div class="training-list-date">
                <div class="date">
                  <div class="day">{{ item.StartOn | moment('DD') }}</div>
                  <div class="month">{{ item.StartOn | moment('MMM') }}</div>
                </div>
                <div class="number">{{ item.Number }}</div>
              </div>
              <div class="training-list-detail">
                <div class="title">
                  <h3>
                    <a :href="`/Course/Detail/${item.Id}`">{{
                      item.Title
                    }}</a>
                  </h3>
                </div>
                <ul class="detail">
                  <li v-if="item.Location">
                    <i class="fas fa-map-marker-alt fa-fw"></i>課程地點：<br
                      class="br-tag"
                    />{{ item.Location }}
                  </li>
                  <li v-if="item.StartOn">
                    <i class="far fa-clock fa-fw"></i>上課時間：<br
                      class="br-tag"
                    />{{ item.StartOn | moment('YYYY.MM.DD HH:mm')}}~{{ item.EndOn | moment('YYYY.MM.DD HH:mm')}}
                  </li>
                  <li v-if="item.ParticipantStartOn">
                    <i class="far fa-calendar fa-fw"></i>報名日期：<br
                      class="br-tag"
                    />{{ item.ParticipantStartOn | moment('YYYY.MM.DD')}}-{{ item.ParticipantEndOn | moment('YYYY.MM.DD')}}
                  </li>
                  <li v-if="item.Quota">
                    <i class="fas fa-user-friends fa-fw"></i>招募名額：<br
                      class="br-tag"
                    />{{ item.Quota }}
                  </li>
                  <li v-if="item.Echelon">
                    <i class="fas fa-star fa-fw"></i>活動梯次：<br
                      class="br-tag"
                    />{{ item.Echelon }}
                  </li>
                  <li >
                    <i class="far fa-edit fa-fw"></i>認列時數：<br
                      class="br-tag"
                    />{{ item.Hours }}
                  </li>
                </ul>
              </div>
              <div class="training-list-btn" :class="{ full: item.ParticipantCount >= item.Quota, over:  new Date() > new Date(item.ParticipantEndOn) || new Date() < new Date(item.ParticipantStartOn) || item.ParticipantCount >= item.Limit}">
                <div class="btn-bg">
                  <div class="left">
                    <div v-if="item.Quota > item.ParticipantCount">
                      <div class="text">剩餘名額</div>
                      <div class="number">{{ item.Quota - item.ParticipantCount}}</div>
                    </div>
                    <div v-if="item.Quota <= item.ParticipantCount">
                      <div class="full">
                        滿額遞補<br />{{ item.ParticipantCount}}/{{ item.Quota }}
                      </div>
                    </div>
                  </div>
                  <div class="btn">
                    <a
                      v-if="item.Quota > item.ParticipantCount && new Date() < new Date(item.ParticipantEndOn) && new Date() > new Date(item.ParticipantStartOn)"
                      title="前往報名"
                      :href="`/Course/Participant/${item.Id}`"
                      >我要報名</a
                    >
                    <!-- @click.prevent="openPopup(item.Id)" -->
                    <a
                      v-else-if="item.Quota <= item.ParticipantCount && new Date() < new Date(item.ParticipantEndOn) && new Date() > new Date(item.ParticipantStartOn)"
                      title="前往候補報名"
                      :href="`/Course/Participant/${item.Id}`"
                      >候補報名</a
                    >
                    <a
                      v-else-if="new Date() < new Date(item.ParticipantStartOn)"
                      title="尚未開放"
                      href="#"
                      >尚未開放</a
                    >
                    <a
                      v-else-if="item.ParticipantCount >= item.Limit"
                      title="報名額滿"
                      href="#"
                      >報名額滿</a
                    >
                    <a
                      v-else
                      title="報名截止"
                      href="#"
                      >報名截止</a
                    >
                    <!-- @click.prevent="openPopup(item.Id)" -->
                  </div>
                </div>
              </div>
            </div>
            <div class="table-line"></div>
          </div>
        </template>
        <!-- 沒內容時顯示這個區塊 -->
        <template v-if="trainingList && trainingList.length === 0">
          <div class="no-training">目前沒有課程。</div>
        </template>
        </div>

      </main>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Api from '@/assets/api/course';
import Footer from '@/components/Footer.vue';
import $ from 'jquery';
import BG from '../assets/images/content_BG01.jpg';
import '../../node_modules/@fortawesome/fontawesome-free/js/all';

export default {
  name: 'traininglist',
  props: {
    courses: {
      type: Object,
    },
  },
  components: {
    Footer,
  },
  data() {
    return {
      BG,
      trainingList: [],
      // eslint-disable-next-line global-require
      scarecrowImg: require('../assets/images/scarecrow.png'),
      alertSet: {
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: '確定',
        confirmButtonAriaLabel: '確定',
        cancelButtonText: '取消',
        cancelButtonAriaLabel: '取消',
        closeButtonAriaLabel: '關閉視窗',
        reverseButtons: true,
        confirmButtonColor: '#4dba95',
        cancelButtonColor: '#bfbfbf',
        width: '1200px',
        html: '',
        focusConfirm: false,
      },
      choosedTraining: '',
      isLoading: false,
      nowPage: 1,
      busy: false, // true觸發載入，false停止載入
      totalPage: 1,
      ms_ie: false,
    };
  },
  methods: {
    openPopup(id) {
      const vm = this;
      vm.choosedTraining = id;
      const tmpHtml = `<h2 class="training-h2 text-flex">
          <img
            src="${vm.scarecrowImg}"
            alt="稻草人圖案"
          />個人資料聲明同意書
        </h2>
        <p>
          本人擬報名參加財團法人全國認證基金會(下稱「TAF」)舉辦之研討會/訓練課程，茲由TAF告知本人個人資料蒐集、處理、利用等相關事項如下：<br />一、蒐集之特定目的TAF基於教育或訓練行政、及代為向政府機關及經濟部中小企業申報終身學習時數、醫事檢驗學會申報醫事檢驗學分之特定目的蒐集、處理、利用本人之個人資料。<br />
          二、蒐集及處理之個人資料類別<br />
          (一)
          辨識個人者。如中英文姓名、身分證字號、相關證書編號、通訊聯絡資訊(E-mail、聯絡住址、電話)等。<br />
          (二) 個人描述。如服務單位名稱、部門等。<br />
          (三) 其他。如發票開立相關資訊等。<br />
          三、利用之期間、地區、對象及方式本人同意TAF於特定目的存續期間、相關法令或契約約定就個人資料之保存期間、TAF因執行業務必須之保存期間，在台灣、澎湖、金門、馬祖地區與TAF有業務往來之機構、與TAF往來之合作單位，得以自動化機器或其他非自動化方式利用本人個人資料。<br />
          四、本人知悉就本人提供之個人資料得自費向TAF行使下列權利：<br />
          (一)查詢或請求閱覽。<br />
          (二)請求製給複製本。<br />
          (三)請求補充或更正。<br />
          (四)請求停止蒐集、處理或利用。<br />
          (五)請求刪除。<br />
          五、本人得自由選擇是否提供本人個人資料，但本人提供之個人資料，如有內容不完整，或經TAF發現不足以確認本人身分真實性，或其他個人資料冒用，個人資料不實等情形，可能喪失參與訓練課程資格、錯誤申報學習時數或或檢驗學分等相關權利。<br />
          本人同意TAF基於上述特定目的蒐集或處理本人個人資料，並於特定目的之必要範圍內利用本人個人資料。<br /><br />
        </p>
        <h3 class="training-h3">
          [聲明：請報名人親自報名，如未經他人同意擅自使用他人個人資料報名，將有相關民刑事責任。]
        </h3>
        <div class="pop-check">
          ※<input type="checkbox" v-model="isChecked" id="popCheck" /><label
            for="popCheck"
            >我已詳閱TAF個人資料同意書並且同意遵守所有規定</label
          >
        </div>`;
      vm.alertSet.html = tmpHtml;
      vm.$swal(vm.alertSet).then((result) => {
        if (result.isConfirmed) {
          if ($('#popCheck').prop('checked')) {
            // vm.$router.push(`/trainingList/registration/${vm.choosedTraining}`);
            window.location.href = `/Course/Participant/${vm.choosedTraining}`;
          } else {
            vm.noCheckDialog();
          }
        }
      });
    },
    noCheckDialog() {
      const vm = this;
      vm.$swal({
        icon: 'warning',
        text: '請勾選我已詳閱TAF個人資料同意書並且同意遵守所有規定',
        confirmButtonColor: '#4dba95',
        confirmButtonText: '確定',
        confirmButtonAriaLabel: '確定',
        focusConfirm: true,
      }).then(() => {
        vm.openPopup(vm.choosedTraining);
      });
    },
    getList(page) {
      const vm = this;
      vm.isLoading = true;
      Api.getAllCourse(page).then((res) => {
        vm.isLoading = false;
        if (res.status === 200) {
          vm.busy = false;
          vm.totalPage = Math.ceil(parseInt(res.data.Data.Total, 10) / 10);
          vm.trainingList = vm.trainingList.concat(res.data.Data.Courses);
        }
      });
    },
    loadMore() {
      const vm = this;
      vm.busy = true;
      if (!vm.totalPage || vm.totalPage === 1 || vm.totalPage === vm.nowPage) {
        vm.busy = false;
        // console.log('no load');
      } else {
        vm.isLoading = true;
        vm.nowPage += 1;
        // console.log('load');
        vm.getList(vm.nowPage);
      }
    },
    // closePopup() {
    //   const vm = this;
    //   vm.isPopup = false;
    // },
  },
  created() {
    const vm = this;
    // console.log(vm.courses);
    // console.log(vm.trainingList);
    if (vm.courses) {
      const obj = JSON.parse(vm.courses);
      vm.trainingList = obj.Courses;
      // console.log(vm.trainingList);
      vm.totalPage = Math.ceil(parseInt(obj.Total, 10) / 10);
    } else {
      vm.getList(vm.nowPage);
    }
    const ua = window.navigator.userAgent;
    const oldIe = ua.indexOf('MSIE ');
    const newIe = ua.indexOf('Trident/');
    if ((oldIe > -1) || (newIe > -1)) {
      vm.ms_ie = true;
    }
    // vm.trainingList = [
    //   {
    //     Title: '2020年電性暨光學測試領域實驗室主管在職訓練 (臺北場/高雄場)',
    //     Location: '高雄國際會議中心(603會議室)高雄市鹽埕區中路四路274號',
    //     Id: 'LAT20003',
    //     Time: '2020.06.27  09:00~17:00',
    //     StartOn: '2020.05.01',
    //     EndOn: '2020.06.01',
    //     Quota: '150',
    //     Echelon: '1',
    //     Left: '52',
    //     IsFull: false,
    //   },
    //   {
    //     Title: '2020年電性暨光學測試領域實驗室主管在職訓練 (臺北場/高雄場)',
    //     Location: '高雄國際會議中心(603會議室)高雄市鹽埕區中路四路274號',
    //     Id: 'LAT20004',
    //     Time: '2020.07.27  09:00~17:00',
    //     StartOn: '2020.06.01',
    //     EndOn: '2020.07.01',
    //     Quota: '150',
    //     Echelon: '1',
    //     Left: '52',
    //     Limit: '150',
    //     Now: '161',
    //     IsFull: true,
    //   },
    //   {
    //     Title: '2020年電性暨光學測試領域實驗室主管在職訓練 (臺北場/高雄場)',
    //     Location: '高雄國際會議中心(603會議室)高雄市鹽埕區中路四路274號',
    //     Id: 'LAT20005',
    //     Time: '2020.08.27  09:00~17:00',
    //     StartOn: '2020.07.01',
    //     EndOn: '2020.08.01',
    //     Quota: '150',
    //     Echelon: '1',
    //     Left: '52',
    //     IsFull: false,
    //   },
    //   {
    //     Title: '2020年電性暨光學測試領域實驗室主管在職訓練 (臺北場/高雄場)',
    //     Location: '高雄國際會議中心(603會議室)高雄市鹽埕區中路四路274號',
    //     Id: 'LAT20006',
    //     Time: '2020.09.27  09:00~17:00',
    //     StartOn: '2020.08.01',
    //     EndOn: '2020.09.01',
    //     Quota: '150',
    //     Echelon: '1',
    //     Left: '52',
    //     IsFull: false,
    //   },
    //   {
    //     Title: '2020年電性暨光學測試領域實驗室主管在職訓練 (臺北場/高雄場)',
    //     Location: '高雄國際會議中心(603會議室)高雄市鹽埕區中路四路274號',
    //     Id: 'LAT20007',
    //     Time: '2020.10.27  09:00~17:00',
    //     StartOn: '2020.09.01',
    //     EndOn: '2020.10.01',
    //     Quota: '150',
    //     Echelon: '1',
    //     Left: '52',
    //     IsFull: false,
    //   },
    // ];
  },
  // filters: {
  //   dayFormat(data) {
  //     return data.split('.')[2].split(' ')[0];
  //   },
  //   monthFormat(data) {
  //     let tmpMonth = data.split('.');
  //     switch (tmpMonth[1]) {
  //       case '01':
  //         tmpMonth = 'JAN';
  //         break;
  //       case '02':
  //         tmpMonth = 'FEB';
  //         break;
  //       case '03':
  //         tmpMonth = 'MAR';
  //         break;
  //       case '04':
  //         tmpMonth = 'APR';
  //         break;
  //       case '05':
  //         tmpMonth = 'MAY';
  //         break;
  //       case '06':
  //         tmpMonth = 'JUN';
  //         break;
  //       case '07':
  //         tmpMonth = 'JUL';
  //         break;
  //       case '08':
  //         tmpMonth = 'AUG';
  //         break;
  //       case '09':
  //         tmpMonth = 'SEP';
  //         break;
  //       case '10':
  //         tmpMonth = 'OCT';
  //         break;
  //       case '11':
  //         tmpMonth = 'NOV';
  //         break;
  //       case '12':
  //         tmpMonth = 'DEC';
  //         break;

  //       default:
  //         break;
  //     }
  //     return tmpMonth;
  //   },
  // },
};
</script>

<style lang="scss">
.other-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.training-content {
  padding: 0 4rem 300px 4rem;
  @media (max-width: 1024px) {
    padding: 0 0 300px 0;
  }
}

.training-h2 {
  background: linear-gradient(to bottom, #a0c8c0 0, #5aa3a8 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h2-ie {
  color:  #5aa3a8;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.table-line {
  height: 1px;
  background-color: #edf1f1;
  width: 100%;
}

.training-list-content {
  display: flex;
  padding: 1.5rem 0;
  @media (max-width: 767px) {
    flex-direction: column;
  }
}

.training-list-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;

  @media (max-width: 767px) {
    justify-content: center;
    margin-bottom: 1rem;
  }
  .date {
    border-radius: 50%;
    width: 98px;
    height: 98px;
    background-color: #7eb9a6;
    padding: 1rem 0.75rem;
    margin-bottom: 9px;

    .day {
      text-align: start;
      font-size: 2rem;
      margin-bottom: 0.5rem;
    }

    .month {
      text-align: right;
      font-size: 1.5rem;
    }
  }

  .number {
    background-color: #fed018;
    font-size: 1.3rem;
    border-radius: 5px;
    padding: 9px 5px;
  }
}

.training-list-detail {
  flex: 1;
  padding: 0 1rem 0 1.5rem;
  @media (max-width: 767px) {
    padding: 0;
  }
  .title {
    a {
      color: #307cb6;
      font-size: 1.5rem;
      letter-spacing: 5px;
      text-decoration: none;
    }
  }

  .detail {
    padding: 10px;

    @media (max-width: 767px) {
      padding: 10px 0;
    }

    .fa-map-marker-alt,
    .fa-clock,
    .fa-calendar,
    .fa-user-friends,
    .fa-star,
    .fa-edit {
      font-size: 1.1rem;
      color: #909090;
    }
    .fa-fw {
      display: inline-block;
      margin-right: 5px;
    }

    li {
      padding-top: 10px;
      color: #909090;
      letter-spacing: 5px;
      @media (max-width: 767px) {
        line-height: 1.5;
      }
    }
  }
}

.training-list-btn {
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    justify-content: center;
  }
  // 可報名&普通狀態
  .btn-bg {
    background-color: #4dba95;
    padding: 8px 12px;
    border-radius: 10px;
    transition: all 0.5s;
    border: 1px solid #eeeeee;

    .left {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      margin: 0 auto;
      background-color: #fff;
      color: #4dba95;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 6px;

      .text {
        margin-bottom: 0.75rem;
      }

      .number {
        font-size: 1.5rem;
      }
    }

    .btn {
      font-size: 1.5rem;
      a {
        display: block;
        color: #fff;
        text-decoration: none;
        padding: 9px 10px;
        background-color: #4dba95;
        border-radius: 10px;
      }
    }
  }
  // 可報名&hover
  .btn-bg {
    &:hover {
      transition: all 0.5s;
      background-color: #fff;
      .left {
        color: #b6b6b6;
        border: 1px solid #b6b6b6;
      }
    }
  }
  // 候補&普通狀態
  &.full {
    .btn-bg {
      background-color: #eb4141;

      .left {
        color: #eb4141;

        .full {
          font-size: 1.1rem;
        }
      }

      .btn {
        font-size: 1.5rem;
        a {
          background-color: #eb4141;
        }
      }
    }
  }
  // 候補&hover
  &.full {
    .btn-bg {
      &:hover {
        transition: all 0.5s;
        background-color: #fff;
        .left {
          // color: #b6b6b6;
          border: 1px solid #b6b6b6;
        }
      }
    }
  }
  &.over {
    .btn-bg {
      background-color: #b6b6b6;

      .left {
        color: #b6b6b6;

        .full {
          font-size: 1.1rem;
        }
      }

      .btn {
        font-size: 1.5rem;
        a {
          background-color: #b6b6b6;
          pointer-events: none;
          cursor: default;
        }
      }
    }
  }
}

.no-training {
  text-align: center;
  padding: 2rem 0;
  font-size: 3rem;
  color: #4dba95;
}

.br-tag {
  display: none;
  @media (max-width: 767px) {
    display: initial;
  }
}

#AC,#AU {
  color: transparent;
}

.text-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-right: 0.5rem;
  }
}

.training-h3 {
  font-size: 1.5rem;
  text-align-last: left;
}

.pop-check {
  text-align: center;
  font-size: 1.5rem;
  color: #f98d28;
  padding: 10px 0;
  input[type="checkbox"] {
    border: 2px solid #f98d28;
    width: 16px;
    height: 16px;
  }
}

// sweetalert 客製
.swal2-content {
  padding: 0 1rem;

  p {
    text-align-last: left;
    font-size: 1.1rem;
  }
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-cancel {
  font-size: 1.5rem;
  border-radius: 5rem;
  font-weight: bold;
  padding: 10px 55px;
}

.swal2-styled:focus {
  outline: 3px dashed #5da3ab;
}
</style>
